import React, { useEffect } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import { useOutletContext } from "react-router-dom";
function Contactadmin() {
  const { user, token } = useOutletContext();
  useEffect(() => {
    if (user?.status === "approved") {
      window.location.href = "/";
    }
  }, [user])
  console.log(user);
  return (
    <div>
      <Header />
      <Leftmenu />
      <div
        className="main-content bg-lightblue theme-dark-bg right-chat-active"
        style={{ minHeight: "100vh" }}
      >
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                  <a href="/" className="d-inline-block mt-2"><i className="ti-arrow-left font-sm text-white" /></a>
                  <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">Registration Completed</h4>
                </div>
                <div className="card-body p-lg-5 p-4 w-100 border-0 text-center">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ps-0">
                        <h4 className="mb-4 font-lg fw-700 mont-font mb-5">Your Registration is Completed </h4>
                        <img src="/images/complete.gif" className="w-75" />
                      </div>
                      <p className="text-muted">
                        Please wait till admin approve your account
                      </p>



                    </div>

                  </div>
                </div>
              </div>
              {/* <div class="card w-100 border-0 p-2"></div> */}
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Contactadmin